import { render, staticRenderFns } from "./purchaseReturnReviewRecord.vue?vue&type=template&id=c2258454"
import script from "./purchaseReturnReviewRecord.vue?vue&type=script&lang=js"
export * from "./purchaseReturnReviewRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports